<template>
  <base-form :title="$t('generic.details')"
             :loading="loading"
             class="row"
             @submit="onSubmit">

    <fg-input :label="$t('generic.client')"
              :error="getError($t('generic.client'))">
      <client-autocomplete v-model="selectedClient"
                           :name="$t('generic.client')"
                           :clearable="false"
                           v-validate="'required|not_empty_object'"
                           @change="onClientChange">
      </client-autocomplete>
    </fg-input>
    <fg-input v-if="showOrganizationField"
              :label="$t('generic.organization')"
              :placeholder="$t('generic.organization')">
      <organization-autocomplete :organization="selectedOrganization"
                                 allow-create
                                 @change="onOrganizationChange"
                                 :name="$t('job.create.details.organization')">
      </organization-autocomplete>
      <small slot="infoBlock">{{$t('job.create.details.organization.infoBlock')}}</small>
    </fg-input>
    <fg-input :label="$t('generic.status')">
      <el-select v-model="model.active" class="select-default">
        <el-option v-for="option in statusOptions"
                   :key="option.label"
                   v-bind="option"
                   class="select-default"/>
      </el-select>
    </fg-input>
    <fg-input :placeholder="$t('client.management.contract.validTill')"
              :name="$t('client.management.contract.validTill')"
              :label="$t('client.management.contract.validTill')"
              component="el-date-picker"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="model.valid_till">
      <small slot="infoBlock">
        <i class="fas fa-info-circle text-muted"></i>&nbsp;
        <span>{{$t('subscriptions.validTill.info')}}</span>
      </small>
    </fg-input>
  </base-form>
</template>
<script>
  import Vue from 'vue'
  import { Select, Option, DatePicker } from 'element-ui'
  import getByKey from 'lodash/get'
  import SubscriptionService from 'src/services/SubscriptionService'
  import ClientService from 'src/services/ClientService'
  import ClientAutocomplete from 'src/components/Autocomplete/ClientAutocomplete'
  import OrganizationAutocomplete from 'src/components/Autocomplete/OrganizationAutocomplete'
  import OrganizationService from 'src/services/OrganizationService'

  Vue.use(DatePicker)
  export default {
    name: 'subscriptions-details',
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      ClientAutocomplete,
      OrganizationAutocomplete,
    },
    data () {
      return {
        model: {},
        selectedClient: {},
        selectedOrganization: {},
        showOrganizationField: false,
        statusOptions: [
          {
            label: this.$t('generic.active'),
            value: true
          },
          {
            label: this.$t('generic.inactive'),
            value: false
          }
        ]
      }
    },
    computed: {},
    methods: {
      getByKey,
      onClientChange (client) {
        this.model.client_uuid = client.uuid
      },
      onOrganizationChange (organization) {
        this.model.organisation_id = organization.id
      },
      async getInitialData () {
        try {
          this.loading = true
          let {data} = await SubscriptionService.getById(this.$route.params.subscriptionId, {
            with: 'client,order,product_job_board'
          })
          let clientData = await ClientService.getById(data.client_uuid)
          this.model = data
          this.selectedClient = clientData.data
          let productType = getByKey(data, 'product_job_board.product_type')
          let isFeaturedEmployerProduct = productType === 'featured_employer'
          this.showOrganizationField = isFeaturedEmployerProduct
          if (isFeaturedEmployerProduct && data.organisation_id) {
            let organizationData = await OrganizationService.getById(data.organisation_id)
            this.selectedOrganization = organizationData.data
          }
        } finally {
          this.loading = false
        }
      },
      async onSubmit () {
        try {
          this.loading = true
          await SubscriptionService.update(this.model.id, this.model)
          this.$router.push(`/contacts/clients/${this.model.client_uuid}/subscriptions`)
        } finally {
          this.loading = false
        }
      }
    },
    async created () {
      await this.getInitialData()
    }
  }
</script>
<style>
</style>
